<template>
	<div>
		<div class="row">
			<!-- <div :class="ProyectoDocumento.Tipo=='3' ? 'col-lg-3' : 'col-lg-6'">
				<label>Nombre *</label>
				<input type="text" class="form-control" v-model="ProyectoDocumento.Nombre"/>
				<Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
			</div> -->
			<!-- <div class="col-lg-6">
				<label>Dirigido A</label>
				<input type="text" class="form-control" v-model="ProyectoDocumento.DirigidoA"/>
			</div> -->
			<div :class="ProyectoDocumento.Tipo=='3' ? 'col-lg-3' : 'col-lg-6'">
				<label>Tipo *</label>
				<select v-model="ProyectoDocumento.Tipo" class="form-control" @change="ChangeModalSize">
					<option value="">-Tipo-</option>
					<option value="1">Personal</option>
					<option value="2">Contratista</option>
					<option value="3">RFI</option>
					<option value="4">Seguridad</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="errorvalidacion.Tipo[0]"></Cvalidation>
			</div>
			<div v-if="ProyectoDocumento.Tipo=='3'" class="col-lg-4">
				<label>No. de Código</label>
				<select v-model="ProyectoDocumentoRfi.NoCodigo" class="form-control">
					<option value="">-No. Codigo-</option>
					<option value="1">Cambio Diseño</option>
					<option value="2">Cambio Contrato</option>
					<option value="3">Variación</option>
					<option value="4">Clarificación</option>
					<option value="5">Requerimiento Menor</option>
					<option value="6">Información Adicional</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.NoCodigo" :Mensaje="errorvalidacion.NoCodigo[0]"></Cvalidation>
			</div>
			<div v-if="ProyectoDocumento.Tipo=='3'" class="col-lg-4">
				<label>Área</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.Area"/>
				<Cvalidation v-if="this.errorvalidacion.Area" :Mensaje="errorvalidacion.Area[0]"></Cvalidation>
			</div>
			<!-- <div :class="ProyectoDocumento.Tipo=='3' ? 'col-lg-3' : 'col-lg-6 mt-3'">
				<label>Item *</label>
				<select v-model="ProyectoDocumento.IdProyectoPrograma" class="form-control">
					<option value="">-Item-</option>
					<option v-for="(item,index) in ListaProyectoPrograma" :key="index" :value="item.IdProyectoPrograma">{{item.Titulo}}</option>
				</select>
			</div>
			<div v-if="ProyectoDocumento.Tipo=='3'" class="col-lg-3">
				<label>Material de Referencia</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.MaterialReferencia"/>
				<Cvalidation v-if="this.errorvalidacion.MaterialReferencia" :Mensaje="errorvalidacion.MaterialReferencia[0]"></Cvalidation>
			</div> -->
		</div>
		<div v-if="ProyectoDocumento.Tipo=='3'" class="row mt-3">
			<div class="col-lg-3">
				<label>Especificación/Sección</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.Especificacion"/>
				<Cvalidation v-if="this.errorvalidacion.Especificacion" :Mensaje="errorvalidacion.Especificacion[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>No. Plano *</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.NoPlano"/>
				<Cvalidation v-if="this.errorvalidacion.NoPlano" :Mensaje="errorvalidacion.NoPlano[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>No. Detalle</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.NoDetalle"/>
				<Cvalidation v-if="this.errorvalidacion.NoDetalle" :Mensaje="errorvalidacion.NoDetalle[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>No. Nota</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.NoNota"/>
				<Cvalidation v-if="this.errorvalidacion.NoNota" :Mensaje="errorvalidacion.NoNota[0]"></Cvalidation>
			</div>
		</div>
		<div v-if="ProyectoDocumento.Tipo=='3'" class="row mt-3">
			<div class="col-lg-3">
				<label>Impacto Costo</label>
				<select v-model="ProyectoDocumentoRfi.ImpactoCosto" class="form-control">
					<option value="">-Impacto Costo-</option>
					<option value="1">Sin Impacto</option>
					<option value="2">Incrementa</option>
					<option value="3">Reduce</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.ImpactoCosto" :Mensaje="errorvalidacion.ImpactoCosto[0]"></Cvalidation>
			</div>
			<div class="col-lg-4">
				<label>Impacto Programación Obra</label>
				<select @change="ChangeBlockDias" v-model="ProyectoDocumentoRfi.ImpactoPrograma" class="form-control">
					<option value="">-Impacto Programa-</option>
					<option value="1">Sin Impacto</option>
					<option value="2">Incrementa Días</option>
					<option value="3">Reduce Días</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.ImpactoPrograma" :Mensaje="errorvalidacion.ImpactoPrograma[0]"></Cvalidation>
			</div>
			<div class="col-lg-2">
				<label>Días</label>
				<input :disabled="BlockDias===true" type="text" class="form-control" v-model="ProyectoDocumentoRfi.Dias"/>
				<Cvalidation v-if="this.errorvalidacion.Dias" :Mensaje="errorvalidacion.Dias[0]"></Cvalidation>
			</div>
			<div v-if="ProyectoDocumento.Tipo=='3'" class="col-lg-3">
				<label>Expedido *</label>
				<v-date-picker v-model="ProyectoDocumento.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.Fecha" :Mensaje="errorvalidacion.Fecha[0]"></Cvalidation>
			</div>
		</div>
		<div v-if="ProyectoDocumento.Tipo=='3'" class="row mt-3">
			<div class="col-lg-3">
				<label>Requerido por:</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.Requerido"/>
				<Cvalidation v-if="this.errorvalidacion.Requerido" :Mensaje="errorvalidacion.Requerido[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Requerido</label>
				<v-date-picker v-model="ProyectoDocumentoRfi.FechaRequerido" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.FechaRequerido" :Mensaje="errorvalidacion.FechaRequerido[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Autorizado por:</label>
				<input type="text" class="form-control" v-model="ProyectoDocumentoRfi.Autorizado"/>
				<Cvalidation v-if="this.errorvalidacion.Autorizado" :Mensaje="errorvalidacion.Autorizado[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Autorizado</label>
				<v-date-picker v-model="ProyectoDocumentoRfi.FechaAutorizado" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.FechaAutorizado" :Mensaje="errorvalidacion.FechaAutorizado[0]"></Cvalidation>
			</div>
		</div>

		<div class="row mt-3">
			<div v-if="ProyectoDocumento.Tipo!='3'" class="col-lg-4">
				<label>Expedido *</label>
				<v-date-picker v-model="ProyectoDocumento.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.Fecha" :Mensaje="errorvalidacion.Fecha[0]"></Cvalidation>
			</div>
			<div class="col-lg-8">
				<label>Documento</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="documento" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="Archivo" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
			<div v-if="ProyectoDocumento.Tipo=='3'" class="col-lg-4">
				<label>Estatus</label>
				<select v-model="ProyectoDocumentoRfi.Estatus" class="form-control">
					<option value="">-Estatus-</option>
					<option value="1">Abierto</option>
					<option value="2">Cerrado</option>
					<option value="3">Cerrado e Incorporado</option>
					<option value="4">Cerrado y no Incorporado</option>
				</select>
				<!-- <v-date-picker v-model="ProyectoDocumentoRfi.FechaEstatus" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.FechaEstatus" :Mensaje="errorvalidacion.FechaEstatus[0]"></Cvalidation> -->
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<label>Descripción</label>
				<textarea v-model="ProyectoDocumento.Comentarios" class="form-control" cols="30" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"Documento",
    props:["poBtnSave","pIdProyecto"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Documento',
            EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoDocumento:{
				IdProyectoDocumento:0,
				IdProyecto:0,
				Fecha:'',
				Nombre:'',
				DirigidoA:'',
				Comentarios:'',
				Archivo:'',
				Tipo:'',
				IdProyectoPrograma:''
			},
			ProyectoDocumentoRfi:{
				MaterialReferencia:'',
				Especificacion:'',
				NoPlano:'',
				NoDetalle:'',
				NoNota:'',
				ImpactoCosto:'',
				ImpactoPrograma:'',
				Dias:'',
				Requerido:'',
				Autorizado:'',
				FechaRequerido:'',
				FechaEstatus:'',
				NoCodigo:'',
				Area:'',
				FechaAutorizado:'',
				Estatus:''
			},
			Archivo:'Elegir Archivo (1MB)',
			errorvalidacion:[],
			ListaProyectoPrograma:[],
			BlockDias:false
		}
	},
	methods: {
		async Guardar(){
			let Fecha='';
			if (this.ProyectoDocumento.Fecha!='' && this.ProyectoDocumento.Fecha!=undefined) {
                let day=this.ProyectoDocumento.Fecha.getDate();
                let month=this.ProyectoDocumento.Fecha.getMonth()+1;
                let year=this.ProyectoDocumento.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let formData=new FormData();
			formData.set('IdProyectoDocumento',this.ProyectoDocumento.IdProyectoDocumento);
			formData.set('IdProyecto',this.ProyectoDocumento.IdProyecto);
			// formData.set('IdProyectoPrograma',this.ProyectoDocumento.IdProyectoPrograma);
			formData.set('Nombre',this.ProyectoDocumento.Nombre);
			formData.set('DirigidoA',this.ProyectoDocumento.DirigidoA);
			formData.set('Tipo',this.ProyectoDocumento.Tipo);
			formData.set('Comentarios',this.ProyectoDocumento.Comentarios);
			formData.set('Archivo',this.ProyectoDocumento.Archivo);
			formData.set('Fecha',Fecha);
			let image=this.$refs.documento.files[0];
			formData.append('ArchivoFile',image);
			switch (this.ProyectoDocumento.Tipo) {
				case '3':
					let FechaRequerido='';
					// let FechaEstatus='';
					let FechaAutorizado='';
					if (this.ProyectoDocumentoRfi.FechaRequerido!='' && this.ProyectoDocumentoRfi.FechaRequerido!=undefined) {
            		    let day=this.ProyectoDocumentoRfi.FechaRequerido.getDate();
            		    let month=this.ProyectoDocumentoRfi.FechaRequerido.getMonth()+1;
            		    let year=this.ProyectoDocumentoRfi.FechaRequerido.getFullYear();
            		    FechaRequerido=year+'-'+month+'-'+day;   
            		}
					if (this.ProyectoDocumentoRfi.FechaAutorizado!='' && this.ProyectoDocumentoRfi.FechaAutorizado!=undefined) {
            		    let day=this.ProyectoDocumentoRfi.FechaAutorizado.getDate();
            		    let month=this.ProyectoDocumentoRfi.FechaAutorizado.getMonth()+1;
            		    let year=this.ProyectoDocumentoRfi.FechaAutorizado.getFullYear();
            		    FechaAutorizado=year+'-'+month+'-'+day;   
            		}
					// if (this.ProyectoDocumentoRfi.FechaEstatus!='' && this.ProyectoDocumentoRfi.FechaEstatus!=undefined) {
            		//     let day=this.ProyectoDocumentoRfi.FechaEstatus.getDate();
            		//     let month=this.ProyectoDocumentoRfi.FechaEstatus.getMonth()+1;
            		//     let year=this.ProyectoDocumentoRfi.FechaEstatus.getFullYear();
            		//     FechaEstatus=year+'-'+month+'-'+day;   
            		// }
					// formData.set('MaterialReferencia',this.ProyectoDocumentoRfi.MaterialReferencia);
					formData.set('Especificacion',this.ProyectoDocumentoRfi.Especificacion);
					formData.set('NoPlano',this.ProyectoDocumentoRfi.NoPlano);
					formData.set('NoDetalle',this.ProyectoDocumentoRfi.NoDetalle);
					formData.set('NoNota',this.ProyectoDocumentoRfi.NoNota);
					formData.set('ImpactoCosto',this.ProyectoDocumentoRfi.ImpactoCosto);
					formData.set('ImpactoPrograma',this.ProyectoDocumentoRfi.ImpactoPrograma);
					formData.set('Dias',this.ProyectoDocumentoRfi.Dias);
					formData.set('Requerido',this.ProyectoDocumentoRfi.Requerido);
					formData.set('Autorizado',this.ProyectoDocumentoRfi.Autorizado);
					formData.set('NoCodigo',this.ProyectoDocumentoRfi.NoCodigo);
					formData.set('Area',this.ProyectoDocumentoRfi.Area);
					formData.set('Estatus',this.ProyectoDocumentoRfi.Estatus);
					formData.set('FechaRequerido',FechaRequerido);
					formData.set('FechaAutorizado',FechaAutorizado);
					// formData.set('FechaEstatus',FechaEstatus);
					break;
			}
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectodocumento/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Documento").modal("hide");
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoDocumento={
				IdProyectoDocumento:0,
				IdProyecto:0,
				Fecha:new Date(),
				Nombre:'',
				Tipo:'',
				DirigidoA:'',
				Comentarios:'',
				Archivo:'',
				IdProyectoPrograma:''
			};
			this.ProyectoDocumentoRfi={
				MaterialReferencia:'',
				Especificacion:'',
				NoPlano:'',
				NoDetalle:'',
				NoNota:'',
				ImpactoCosto:'',
				ImpactoPrograma:'',
				Dias:'',
				Requerido:'',
				Autorizado:'',
				FechaRequerido:'',
				FechaEstatus:'',
				NoCodigo:'',
				Area:'',
				FechaAutorizado:'',
				Estatus:''
			};
			this.Archivo='Elegir Archivo (1MB)';
			this.errorvalidacion=[];
			this.BlockDias=false;
			// this.ListaProyectoPrograma=[];
		},
		Recuperar(){
			this.$http.get('proyectodocumento/recovery',{
                params:{
                    IdProyectoDocumento:this.ProyectoDocumento.IdProyectoDocumento
                }
            }).then((res)=>{
				const objres=res.data.data.proyectodocumento;
				this.ProyectoDocumento.IdProyectoDocumento=objres.IdProyectoDocumento;
				this.ProyectoDocumento.IdProyecto=objres.IdProyecto;
				// this.ProyectoDocumento.IdProyectoPrograma=objres.IdProyectoPrograma;
				this.ProyectoDocumento.Nombre=objres.Nombre;
				this.ProyectoDocumento.Tipo=objres.Tipo;
				this.ProyectoDocumento.DirigidoA=objres.DirigidoA;
				this.ProyectoDocumento.Archivo=objres.Archivo;
				this.ProyectoDocumento.Comentarios=objres.Comentarios;
				let formatedDate = objres.Fecha.replace(/-/g, "\/");
				this.ProyectoDocumento.Fecha=new Date(formatedDate);
				this.Archivo=objres.Archivo;
				// this.GetListaPrograma(this.ProyectoDocumento.IdProyecto);
				switch (this.ProyectoDocumento.Tipo) {
					case '3':
						// this.ProyectoDocumentoRfi.MaterialReferencia=res.data.data.detalles.MaterialReferencia;
						this.ProyectoDocumentoRfi.Especificacion=res.data.data.detalles.Especificacion;
						this.ProyectoDocumentoRfi.NoPlano=res.data.data.detalles.NoPlano;
						this.ProyectoDocumentoRfi.NoDetalle=res.data.data.detalles.NoDetalle;
						this.ProyectoDocumentoRfi.NoNota=res.data.data.detalles.NoNota;
						this.ProyectoDocumentoRfi.ImpactoCosto=res.data.data.detalles.ImpactoCosto;
						this.ProyectoDocumentoRfi.ImpactoPrograma=res.data.data.detalles.ImpactoPrograma;
						this.ProyectoDocumentoRfi.Dias=res.data.data.detalles.Dias;
						this.ProyectoDocumentoRfi.Requerido=res.data.data.detalles.Requerido;
						this.ProyectoDocumentoRfi.Autorizado=res.data.data.detalles.Autorizado;
						this.ProyectoDocumentoRfi.NoCodigo=res.data.data.detalles.NoCodigo;
						this.ProyectoDocumentoRfi.Area=res.data.data.detalles.Area;
						this.ProyectoDocumentoRfi.Estatus=res.data.data.detalles.Estatus;
						let formatedDateRequerido = res.data.data.detalles.FechaRequerido.replace(/-/g, "\/");
						this.ProyectoDocumentoRfi.FechaRequerido=new Date(formatedDateRequerido);
						// let formatedDateEstatus = res.data.data.detalles.FechaEstatus.replace(/-/g, "\/");
						// this.ProyectoDocumentoRfi.FechaEstatus=new Date(formatedDateEstatus);
						let formatedDateAutorizado = res.data.data.detalles.FechaAutorizado.replace(/-/g, "\/");
						this.ProyectoDocumentoRfi.FechaAutorizado=new Date(formatedDateAutorizado);
						break;
					default:
						break;
				}
			}).finally(()=>{
				this.ChangeModalSize();
			});
		},
		SubirArchivo(){
			const image = this.$refs.documento.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                this.$toast.info('Solo se puede subir archivos menores a 1 MB');
                const  input  = this.$refs.documento;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.documento;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (1MB)';
                return false;
            }

            this.Archivo=image.name;
		},
		ChangeModalSize(){
			this.bus.$emit('SwitchModalDocumentSize',this.ProyectoDocumento.Tipo);
		},
		async GetListaPrograma(IdProyecto){
			await this.$http.get('proyectoprograma/get',{
				params:{
					IdProyecto:IdProyecto
				}
			}).then((res)=>{
				this.ListaProyectoPrograma=res.data.data.proyectoprograma;
			})
		},
		ChangeBlockDias(){
			if (this.ProyectoDocumentoRfi.ImpactoPrograma=='1') {
				this.BlockDias=true;
				this.ProyectoDocumentoRfi.Dias=0;
			}
			else{
				this.BlockDias=false;
			}
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
			this.ChangeModalSize();
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoDocumento.IdProyecto=IdProyecto;
				// this.GetListaPrograma(this.ProyectoDocumento.IdProyecto);
            }
            if (Id > 0) {
				this.ProyectoDocumento.IdProyectoDocumento = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
